"use client";

import Core from "@/components/core";
import useFetchLayananData from "@/hooks/fetchLayananData";

const LayananData = () => {
  const layanan = useFetchLayananData();

  return (
    <>
      {layanan.map((item) => (
        <Core.Card
          key={item.id}
          caseType="blog"
          image={`https://admin.macspace.id/public/${item.image}`}
          title={`Service ${item.name}`}
          content={`MacSpace.id dapat memperbaiki kerusakan pada ${item.name} anda seperti Mati Total, Water Damage dan lain - lain.`} // Assuming 'content' is the same as 'name' since 'description' is not provided in the API response
          link={`/layanan/${item.slug}`}
        />
      ))}
    </>
  );
};

export default LayananData;
